import { constantRoutes } from '@/router'
// 导入获取菜单数据的方法
import { getMenuList } from '@/api/loginApi'
// 导入layout组件
import layout from '@/layout/index.vue'
import { defineAsyncComponent } from 'vue'
/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
export function hasPermission(roles?: any, route?: any) {
  if (route.meta && route.meta.roles) {
    return roles.some((role: any) => route.meta.roles.includes(role))
  } else {
    return true
  }
}
/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes: any[], roles: any) {
  const res: any[] = []
  routes.forEach(route => {
    const tmp = { ...route }
    // 判断是否相应的权限
    if (hasPermission(roles, tmp)) {
      // 获取组件
      const component = tmp.component
      // 判断是否有相应的组件
      if (route.component) {
        // 判断是否是跟组件
        if (component === 'Layout') {
          tmp.component = layout
        } else {
          // 获取对应的具体的组件信息
          // tmp.component = (resolve) => require([`@/views${component}.vue`],resolve)
          // tmp.component=()=>import(`@/views/${component}.vue`)
          // tmp.component = defineAsyncComponent(() => import(`../../views${component}.vue`))
          tmp.component = () => import(`../../views${component}.vue`)
        }
      }
      // 判断是否有子菜单
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })
  return res
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state: { addRoutes: any; routes: any }, routes: any) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  generateRoutes({ commit }: any, roles: any) {
    return new Promise((resolve, reject) => {
      // 发送查询菜单数据的请求
      getMenuList().then((res: any) => {
        // console.log(res)
        // 存放对应权限的路由信息
        let accessedRoutes
        // 如果状态码为200 则表示成功
        if (res.code === 200) {
          accessedRoutes = filterAsyncRoutes(res.data, roles)
        }
        // 将路由信息保存到store中
        commit('SET_ROUTES', accessedRoutes)
        resolve(accessedRoutes)
      }).catch((error: any) => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
